import {
  WatchLater,
  AccessTime,
  Badge,
  CheckCircleRounded,
  Engineering,
  Favorite,
  LocationOn,
  Psychology,
  Schedule,
  WorkHistory,
  MoneyOffCsredRounded,
  Money,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Divider,
  Grid,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/material";
import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import JobDetailsModal from "../../JobList Components/JobDetailsModal";
import "./Job.css";

const JobShortCard = ({ jobData }) => {
  const navigate = useNavigate();
  const {
    job_budget,
    job_title,
    job_currency,
    job_expertlevel,
    job_time,
    job_info,
    poster_locat,
    poster_status,
    job_skill,
    job_id,
    job_refer,
    job_poster,
    job_poster_name,
  } = jobData;

  // Parse skills safely, fallback to empty array
  let skill = [];
  try {
    skill = JSON.parse(job_skill?.split(", ") || "[]");
  } catch {
    skill = [];
  }

  const [jobId, setJobId] = useState("");
  const [jobRefer, setJobRefer] = useState("");
  const [poid, setPoid] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = (refer, id, poid) => {
    setJobId(id);
    setJobRefer(refer);
    setPoid(poid);
    setModalOpen(!modalOpen);
  };

  return (
    <>
      <Paper
        elevation={4}
        onClick={() =>
          navigate(`/JobDetails/${job_id}/${job_refer}/${job_poster}`)
        }
        sx={{
          cursor: "pointer",
          borderRadius: 3,
          p: 2,
          mb: 2,
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          transition: "transform 0.2s, box-shadow 0.3s",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Stack spacing={1}>
              {/* Job Title & Budget */}
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: "black",
                    maxWidth: "70%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {job_title}
                </Typography>
              </Stack>

              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ mt: 1 }}
              >
                <Money
                  sx={{
                    fontSize: 16,
                    color: "#00C9A7",
                  }}
                />
                <Typography
                  variant="body2"
                  color="black"
                  sx={{
                    fontSize: 16,
                  }}
                >
                  {job_currency} {job_budget}
                </Typography>
              </Stack>

              {/* Expert Level and Time */}
              <Stack direction="row" spacing={3} alignItems="center">
                <Stack
                  direction="row"
                  spacing={0.5}
                  alignItems="center"
                  color="text.secondary"
                >
                  <Psychology fontSize="small" sx={{ color: "#00C9A7" }} />
                  <Typography variant="body2">{job_expertlevel}</Typography>
                </Stack>

                <Stack
                  direction="row"
                  spacing={0.5}
                  alignItems="center"
                  color="text.secondary"
                >
                  <WatchLater fontSize="small" sx={{ color: "#00C9A7" }} />
                  <Typography variant="body2">{job_time}</Typography>
                </Stack>
              </Stack>

              {/* Job Info */}
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mt: 1,
                  maxHeight: 48,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {job_info?.length > 60
                  ? `${job_info.slice(0, 60)}...`
                  : job_info}
              </Typography>

              {/* Poster Info */}
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ mt: 1 }}
              >
                <CheckCircleRounded
                  sx={{
                    fontSize: 16,
                    color: poster_status === "1" ? "#00C9A7" : "gray",
                  }}
                />
                <Typography variant="body2" color="text.secondary">
                  {job_poster_name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ||
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {poster_locat}
                </Typography>
              </Stack>

              {/* Skills */}
              <Stack
                direction="row"
                spacing={1}
                flexWrap="wrap"
                sx={{ mt: 1, height: "25px" }}
              >
                {skill.length > 1 ? (
                  skill.slice(0, 2).map((element) => (
                    <Button
                      key={element}
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate("/joblist");
                      }}
                      sx={{
                        bgcolor: "#00C9A7",
                        color: "#fff",
                        textTransform: "capitalize",
                        borderRadius: 20,
                        px: 2,
                        fontSize: 11,
                        "&:hover": {
                          bgcolor: "#0074E4",
                        },
                      }}
                    >
                      {element}
                    </Button>
                  ))
                ) : (
                  <Button
                    key={0}
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/joblist");
                    }}
                    sx={{
                      bgcolor: "#00C9A7",
                      color: "#fff",
                      textTransform: "capitalize",
                      borderRadius: 20,
                      px: 2,
                      fontSize: 11,
                      "&:hover": {
                        bgcolor: "#0074E4",
                      },
                    }}
                  >
                    Join Work
                  </Button>
                )}
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Paper>

      {/* Modal for job details */}
      <JobDetailsModal
        jobId={jobId}
        jobRefer={jobRefer}
        poid={poid}
        modalOpen={modalOpen}
        handleModalOpen={handleModalOpen}
      />
    </>
  );
};

export default JobShortCard;
